/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";

/* import specific icons */
import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import {
  faCircleDown,
  faFile,
  faPenToSquare,
  faPersonChalkboard,
  faPlus,
  faUserSecret,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import {
  faChevronLeft,
  faMemoCircleInfo,
  faListTree,
  faTags,
  faWandMagicSparkles,
  faMoneyCheckPen,
  faShield,
  faCircleInfo,
  faFileInvoiceDollar,
  faCreditCard,
  faMoneyCheckDollar,
  faCalendar,
  faPen,
  faTrashCan,
  faFilterList,
  faMessagesQuestion,
  faClose,
  faPlusCircle,
  faUsers,
  faFileInvoice,
  faFileCircleInfo,
  faShareFromSquare,
  faCircleEllipsis,
  faFileArrowDown,
  faTimesCircle,
  faChartPieSimple,
  faMessagesDollar,
  faBadgePercent,
  faFileCirclePlus,
  faHandHoldingDollar,
  faUsdCircle,
  faHandshake,
  faArrowsRepeat,
  faShieldCheck,
  faRotateLeft,
  faEnvelope,
  faScreenUsers,
  faHandHoldingUsd,
  faCheckCircle,
  faFileExport,
  faChevronUp,
  faChevronDown,
  faMoneyBillTransfer,
  faCircleDollar,
  faDownload,
  faUpload,
  faLaptopMobile,
  faFiles,
  faIdCard,
  faStore,
  faUserPen,
} from "@fortawesome/pro-solid-svg-icons";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

/* Set up using Vue 2 */
import Vue from "vue";

/* add icons to the library */
library.add(
  faUserSecret,
  faChevronLeft,
  faMemoCircleInfo,
  faListTree,
  faTags,
  faWandMagicSparkles,
  faMoneyCheckPen,
  faShield,
  faCircleInfo,
  faFileInvoiceDollar,
  faCreditCard,
  faMoneyCheckDollar,
  faCalendar,
  faPen,
  faTrashCan,
  faFilterList,
  faMessagesQuestion,
  faClose,
  faPlusCircle,
  faUsers,
  faFileInvoice,
  faFileCircleInfo,
  faShareFromSquare,
  faCircleEllipsis,
  faFileArrowDown,
  faTimesCircle,
  faChartPieSimple,
  faMessagesDollar,
  faBadgePercent,
  faFileCirclePlus,
  faHandHoldingDollar,
  faFile,
  faXmark,
  faPlus,
  faUsdCircle,
  faHandshake,
  faArrowsRepeat,
  faShieldCheck,
  faPenToSquare,
  faRotateLeft,
  faEnvelope,
  faCircleDown,
  faScreenUsers,
  faPersonChalkboard,
  faGoogle,
  faHandHoldingUsd,
  faCheckCircle,
  faFileExport,
  faChevronUp,
  faChevronDown,
  faMoneyBillTransfer,
  faCircleDollar,
  faDownload,
  faUpload,
  faLaptopMobile,
  faFiles,
  faIdCard,
  faStore,
  faUserPen,
);

/* add font awesome icon component */
Vue.component("font-awesome-icon", FontAwesomeIcon);
